export const PRICE_DISCLOSURE = "No service fees. 10.25% tax applies";

export const SERVICE_FEE_POLICY =
  "No service fees apply to any offering, including private and non-private weekday parties, additional kids and adults, rentals, extra party time, food, entertainment, decorations, and all other add-ons.";

export const TAX_POLICY = "A 10.25% tax will be applied to the total balance.";

export const CARD_PAYMENT_POLICY =
  "A 3% credit card fee will be charged if payment is made by card.";

export const DEPOSIT_POLICY =
  "A 40% non-refundable deposit is required at the time of booking.";

export const RESCHEDULING_POLICY =
  "You may reschedule your event one time only, subject to availability.";

export const CANCELLATION_POLICY =
  "To cancel or reschedule your event date, a 30-day notice is required. The new date (if rescheduled) must also be within the same calendar year.";

export const BALANCE_POLICY =
  "The remaining balance must be paid on the day of the event.";

export const OTHER_CHARGES_POLICY =
  "Optional add-ons are priced separately. Credit-card, vendor, damage, and overrun charges still apply as described in our booking policies; these are separate from service fees.";

export const bookingPolicies = [
  DEPOSIT_POLICY,
  "Vendor Fee $150/per Vendor",
  RESCHEDULING_POLICY,
  CANCELLATION_POLICY,
  BALANCE_POLICY,
  SERVICE_FEE_POLICY,
  OTHER_CHARGES_POLICY,
  TAX_POLICY,
  CARD_PAYMENT_POLICY,
  "There is a 15-minute grace period after your party ends. Exceeding this time will incur a $300 fee.",
  "Once the party ends, staff will begin cleanup to prepare for open play or the next scheduled party.",
  "All decorations must be removed at the end of the party, with staff available to assist.",
  "Backdrops cannot be hung on the walls.",
  "All guests entering the play area must remove their shoes and wear non-slip socks. If play mats are damaged, a $450 fee will be charged.",
  "No food or beverages are allowed in the play area. If the play area is dirtied or damaged due to food or beverages, a $300 fee will be applied.",
  "Damaging items in the party area, play area, restrooms, or other spaces due to mishandling will result in a $500 fee.",
];
